import { render, staticRenderFns } from "./flow.vue?vue&type=template&id=6d0625ec&"
import script from "./flow.vue?vue&type=script&lang=js&"
export * from "./flow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "flow.vue"
export default component.exports